import styled from 'styled-components';
import {
  desktopBodyLargeCss,
  desktopTitleH5Css,
  desktopTitleH7Css,
  mobileTitleH4Css,
  mobileTitleH7Css,
} from '$base-styles/typography';
import Grid from '$components/layout/Grid';
import Link from '$quantum/atoms/Link/styled';
import { media, vars } from '$util/theme';

const { purple300 } = vars.quantumverse.reskinColors;

export const Styled = styled(Grid)<{ $backgroundColor?: string }>`
  .container {
    ${media.up('lg')} {
      border-radius: 6px;
      overflow: hidden;
    }

    > .Row > {
      .info {
        background-color: ${({ $backgroundColor }) => $backgroundColor || purple300};
        padding: 44px 30px;

        ${media.up('sm')} {
          padding: 53px 34px 42px;
        }

        ${media.up('lg')} {
          padding: 52px 48px 66px;
        }
      }
      .image-wrapper {
        padding: 0;
      }
    }
  }

  .headings {
    .Heading {
      ${mobileTitleH7Css};
      margin-bottom: 8px;
      text-align: center;

      ${media.up('sm')} {
        ${desktopTitleH7Css};
        margin-bottom: 22px;
      }

      ${media.up('lg')} {
        text-align: left;
        margin-bottom: 32px;
      }
    }

    .Subheading {
      ${mobileTitleH4Css};
      text-align: center;
      margin-bottom: 46px;

      ${media.up('sm')} {
        ${desktopBodyLargeCss};
        margin-bottom: 16px;
      }

      ${media.up('lg')} {
        text-align: left;
        margin-bottom: 38px;
      }
    }
  }

  .help-image {
    max-height: 352px;

    ${media.up('sm')} {
      max-height: 400px;
    }

    ${media.up('lg')} {
      max-height: none;
    }

    > span {
      height: 100% !important;
      width: 100% !important;
    }
  }

  .flex {
    display: flex;
    flex-direction: column;
    gap: 32px;

    ${media.up('sm')} {
      gap: 36px;
      flex-direction: row;
    }

    ${media.up('lg')} {
      gap: 16px;
    }
  }
`;

export const ContactItemWrapper = styled.div`
  flex-grow: 1;

  .contact-item {
    display: flex;

    ${media.up('sm')} {
      flex: 1 1 33%;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .contact-item-image-wrapper {
      width: 64px;
      height: 64px;
      margin-right: 30px;

      ${media.up('sm')} {
        margin-bottom: 4px;
        margin-right: 0;
      }
    }

    .contact-item-info {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .contact-item-info-heading {
        ${desktopTitleH5Css};
        margin-bottom: 0;
      }

      .Link,
      .inner-button {
        margin-top: 6px;

        ${media.up('sm')} {
          margin-top: 12px;
        }
      }

      .inner-button {
        display: none;

        ${media.up('sm')} {
          display: block;
        }
      }
    }
    ${Link} {
      margin-left: -8px;
      margin-right: -8px;

      .qvIcon {
        display: none;
      }
    }
  }

  .outer-button {
    width: 100%;
    margin-top: 12px;

    ${media.up('sm')} {
      display: none;
    }
  }
`;
